import ValidationRuleCellPhone from "./ValidationRuleCellPhone";
import ValidationRuleEmail from "./ValidationRuleEmail";
import ValidationRuleEmptyCellPhone from "./ValidationRuleEmptyCellPhone";
import ValidationRuleEmptyPhone from "./ValidationRuleEmptyPhone";
import ValidationRuleNumber from "./ValidationRuleNumber";
import ValidationRulePassword from "./ValidationRulePassword";
import ValidationRulePhone from "./ValidationRulePhone";
import ValidationRuleRequired from "./ValidationRuleRequired";

export default interface IValidationRule {
  message: string | undefined;
  inform?: string | undefined;

  check(value: any): boolean;
}

export type ValidationRuleNames = "required" | "number" | "email" | "phone" | "cellphone" | "password" | "emptyPhone" | "emptyCellphone";

const ValidationRules: {
  [key in ValidationRuleNames]: IValidationRule;
} = {
  required: ValidationRuleRequired.prototype,
  number: ValidationRuleNumber.prototype,
  email: ValidationRuleEmail.prototype,
  phone: ValidationRulePhone.prototype,
  cellphone: ValidationRuleCellPhone.prototype,
  password: ValidationRulePassword.prototype,
  emptyPhone: ValidationRuleEmptyPhone.prototype,
  emptyCellphone: ValidationRuleEmptyCellPhone.prototype,
};

export { ValidationRules };
